import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 22 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createVNode("path", {
  d: "M10.4454 0.16795C10.7813 -0.0559832 11.2189 -0.0559832 11.5548 0.16795L17 3.79808V1.9375C17 1.41973 17.4477 1 18 1C18.5523 1 19 1.41973 19 1.9375V5.0625C19 5.0851 18.9991 5.10752 18.9975 5.12972L21.5548 6.83462C22.0143 7.14097 22.1385 7.76184 21.8322 8.22137C21.5258 8.68089 20.9049 8.80507 20.4454 8.49872L11.0001 2.20185L1.55481 8.49872C1.09528 8.80507 0.474408 8.68089 0.168056 8.22137C-0.138296 7.76184 -0.0141226 7.14097 0.445406 6.83462L10.4454 0.16795Z",
  fill: "currentColor"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createVNode("path", {
  d: "M13.7002 6.01164L19.5955 9.71401C20.4695 10.2629 21 11.2225 21 12.2546V16.4967C21 18.1536 19.6569 19.4967 18 19.4967H4C2.34315 19.4967 1 18.1536 1 16.4967V12.2546C1 11.2225 1.5305 10.2629 2.40449 9.71401L8.16016 6.09934V9.77544H8.15571V10.8053H7.60015C7.17913 10.8053 6.8032 11.069 6.65988 11.4649C6.51655 11.8608 6.63653 12.304 6.95996 12.5735L10.2933 15.3513C10.6641 15.6603 11.2028 15.6603 11.5737 15.3513L14.907 12.5735C15.2304 12.304 15.3504 11.8608 15.2071 11.4649C15.0638 11.069 14.6878 10.8053 14.2668 10.8053H13.7113V9.77544H13.7002V6.01164Z",
  fill: "currentColor"
}, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock("svg", _hoisted_1, [
    _hoisted_2,
    _hoisted_3
  ]))
}